import {PRODUCT_FIND_ALL} from "../utils/Constant";

const product = function (state = {}, action) {
  switch (action.type) {
    case PRODUCT_FIND_ALL:

      return state;
    default :
      return state;
  }
}
export default product;
